export const AUTH_ERROR_KEY = "artis_auth_error";
export const AUTH_REDIRECT_COUNT_KEY = "artis_auth_redirect_count";
export const MAX_AUTH_REDIRECTS = 5;
export const LOGGED_OUT_PARAM = "logged_out";
export const FORCE_LOGIN_PARAM = "force_login";
export const AUTH_CALLBACK_RETRY_KEY = "artis_auth_callback_retry";
export const AUTH_CALLBACK_FAILED = "auth_callback_failed";
